import React, { useEffect, useState } from 'react';
import {
  PieChartOutlined,
  SettingOutlined,
  SmileOutlined,
  TeamOutlined,
  BankOutlined,
  VideoCameraOutlined,
  FileImageOutlined,
  MoneyCollectOutlined
} from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import UserChip from './UserChip';
import { useNavigate, useLocation } from 'react-router-dom';

const { Sider } = Layout;

const siderStyle = {
  height: '100vh', // Full viewport height
  background: '#001529', // Dark theme
  position: 'fixed', // Fixed to stay in place
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  zIndex: 1030,
};

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const AdminSidebar = ({ trigger, collapsible, collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [name, setName] = useState('');

  const items = [
    getItem('Dashboard', '/admin', <PieChartOutlined />),
    getItem('Partners', "/admin/partners", <TeamOutlined />),
    // getItem('Customers', "/admin/customers", <SmileOutlined />),
    getItem('Masters', 'sub1', <SettingOutlined />, [
      getItem('Languages', "/admin/masters/languages"),
      getItem('Time Slots', "/admin/masters/time-slots"),
      getItem('Genre', "/admin/masters/genre"),
      getItem('Seat Type', "/admin/masters/seat-type"),
      getItem('States', "/admin/masters/states"),
      getItem('Districts', "/admin/masters/districts"),
      getItem('Third Parties', "/admin/masters/external-theatre"),
    ]),
    getItem('News & Events', 'sub2', <SmileOutlined />, [
      getItem('News', "/admin/news"),
      getItem('Add News', "/admin/add-news"),
      getItem('Events', "/admin/events"),
      getItem('Event Sections', "/admin/event-sections"),
      getItem('Flash News', "/admin/flash-news"),
    ]),
    // getItem('Theatre Management', "/admin/theatres", <VideoCameraAddOutlined />),
    getItem('Movie Management', 'sub3', <TeamOutlined />, [
      getItem('Upcoming & Now Showing', "/admin/movie/upcoming"),
      getItem('Add New', "/admin/movie/add-new"),
      getItem('Archived', "/admin/movie/archived"),
    ]),

    getItem('Theatre Management', 'sub4', <BankOutlined />, [
      getItem('Theatre', "/admin/theatre"),
      getItem('Add New', "/admin/theatre/add-new"),
      getItem('Add Staff', "/admin/theatre/add-staff"),
    ]),

    getItem('Show Management', 'sub5', <VideoCameraOutlined />, [
      getItem('Shows', "/admin/shows"),
      getItem('Manage Show', "/admin/shows/manage"),
      getItem('History', "/admin/shows/old"),
    ]),

    getItem('Gallery', "/admin/gallery", <FileImageOutlined />),

    getItem('Customer Management', 'sub6', <TeamOutlined />, [
      getItem('Customers', "/admin/customers"),
      getItem('Subscribers', "/admin/subscribers"),
    ]),

    getItem('Booking Management', 'sub7', <MoneyCollectOutlined />, [
      getItem('Ticket snapshots', "/admin/ticket-snapshots"),
      getItem('Succesful bookings', "/admin/paid-bookings"),
      getItem('Unpaid / Cancelled', "/admin/unpaid-bookings"),
      getItem('Missed ticket gen:', "/admin/missed-tickets"),
      getItem('Event Bookings', "/admin/event-bookings"),
      getItem('Event Ticket Snapshots', "/admin/event-ticket-snapshots"),
    ]),
  ];

  useEffect(() => {
    const n = localStorage.getItem("name");
    setName(n);
  }, [])
  

  return (
    <Sider
      style={{
        ...siderStyle,
        width: collapsed ? 0 : 250,
        transition: 'width 0.2s',
      }}
      trigger={trigger}
      collapsible={collapsible}
      collapsed={collapsed}
      breakpoint="lg"
      collapsedWidth="0"
      width={250}
    >
      <div
        style={{
          padding: '8px',
          background: '#001529',
          position: 'sticky',
          top: 0,
          zIndex: 1,
        }}
      >
        <UserChip
          name={name}
          role="Admin"
          avatar=""
          handleCollapse={() => setCollapsed(!collapsed)}
        />
      </div>
      <div
        style={{
          height: 'calc(100vh - 80px)',
          overflowY: 'auto',
          background: '#001529',
          scrollbarWidth: 'thin',
          scrollbarGutter: 'stable',
        }}
      >
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['4']}
          items={items}
          onClick={(e) => navigate(e.key)}
          selectedKeys={[location.pathname]}
        />
      </div>
    </Sider>
  );
};

export default AdminSidebar;
